module.exports = __webpack_public_path__ + "static/media/gameover_bg.2cf76cbd.svg";